exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-small[data-v-1770037b] {\n    padding: 20px 90px 20px;\n    max-width: 1020px;\n    margin: 0 auto;\n}\nh1[data-v-1770037b] {\n    font-size: 40px;\n    font-weight: 700;\n    text-align: center;\n    margin-top: 0;\n    margin-bottom: 30px;\n    color: black;\n}\n@media only screen and (max-width: 634px) {\n.container-small[data-v-1770037b] {\n        padding: 30px;\n}\n}\n@media only screen and (max-width: 575px) {\n.container-small[data-v-1770037b] {\n        padding: 20px;\n}\nh1[data-v-1770037b] {\n        font-size: 29px;\n        line-height: 29px;\n        margin-bottom: 20px;\n}\n}\n", ""]);

// exports
